import Vue from 'vue'
import App from './App.vue'
import http from '@/utils/request'
import ysHttp from '@/utils/requestYs'
import router from './router'
import store from './store'
import '@/icons'

import Vant from 'vant';
import 'vant/lib/index.css';
import '@/utils/common.css'
import day from "dayjs";

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.use(Vant);
import {getDictLabel} from '@/utils'
import 'lib-flexible'

Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$http = http
Vue.prototype.$ysHttp = ysHttp
Vue.prototype.$dayjs = day;
Vue.prototype.$getDictLabel = getDictLabel

Vue.prototype.$tiandituKey = '760f4d836a563d3c78d8f6985dd6a2d9'

Vue.prototype.$cydnToken = ''

// 统一设置点击事件的间隔时间 （注意：页面刷新后失效）
Vue.directive("preventReClick", {
    inserted(el, binding) {
        el.addEventListener("click", () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 1200);
            }
        });
    },
});

var onPlusReady = function (callback, context = this) {
    if (window.plus) {
        callback.call(context)
    } else {
        document.addEventListener('plusready', callback.bind(context))
    }
}

Vue.mixin({
    beforeCreate () {
        onPlusReady(() => { this.plusReady = true }, this)
    },
    methods: {
        onPlusReady: onPlusReady
    },
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
